import { render, staticRenderFns } from "./ToBeSentPcs.vue?vue&type=template&id=015fa070&"
import script from "./ToBeSentPcs.vue?vue&type=script&lang=ts&"
export * from "./ToBeSentPcs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports